module.exports = __webpack_public_path__ + "static/img/garage-door-extension-spring.9858486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/showcase/garage-door-extension-spring.png
// module id = PJ4s
// module chunks = 1